<template>
  <div class="page-my-message-notification">
    <ym-cell class="message-cell"
             title="收到的私信"
             :border="false"
             is-link
             :to="{ name: 'Message' }"
    >
      <span class="new-message"
            v-if="count.message > 0"
      >
        新私信
      </span>
    </ym-cell>
    <ym-cell class="message-cell"
             title="通知消息"
             is-link
             :to="{ name: 'Notification' }"
    >
      <span class="new-notification"
            v-if="count.notification > 0"
      >
        {{ count.notification }}条未读
      </span>
    </ym-cell>
  </div>
</template>

<script>
  import { Cell } from '@ymba/ym-ui';
  import { getMessageIndex } from '@/services/message';

  export default {
    name: 'PageMyInformation',
    metaInfo: {
      title: '消息',
    },
    components: {
      'ym-cell': Cell,
    },
    data() {
      return {
        count: {
          message: 0,
          notification: 0,
        },
      };
    },
    methods: {
      async fetchData() {
        const data = await getMessageIndex();
        this.count = data.count;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-my-message-notification {
    /deep/ .new-message,
    /deep/ .new-notification {
      font-size: @font-size-base;
      font-weight: @font-weight-primary;
      color: @color-text-lighter;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        width: 12px;
        height: 12px;
        border-radius: 6px;
        background: @color-highlight;
        left: -@size-small;
        top: calc(50% - 6px);
      }
    }
  }

</style>
